<template>
    <div class="container-page py-10 md:py-14">
        <SectionHeading title="Education" />

        <div class="card flex flex-col gap-6 p-6 sm:p-9 md:flex-row md:items-center md:justify-between">
            <div class="flex items-center gap-5">
                <div class="flex h-14 w-14 shrink-0 items-center justify-center rounded-2xl bg-accent-soft text-accent">
                    <i class="fa-solid fa-graduation-cap text-[20px]"></i>
                </div>
                <div>
                    <h3 class="font-display text-[22px] font-semibold text-ink">ATILIM University</h3>
                    <p class="mt-1 text-[15px] text-muted">2020 – 2025</p>
                </div>
            </div>

            <div class="flex flex-wrap gap-2">
                <span class="chip !px-4 !py-2 !text-[14px]">Main Field: <span class="ml-1 font-medium text-ink">Software Engineering</span></span>
                <span class="chip !px-4 !py-2 !text-[14px]">GPA: <span class="ml-1 font-medium text-ink">3.65 / 4</span></span>
            </div>
        </div>
    </div>
</template>

<script>
import SectionHeading from '@/components/ui/SectionHeading.vue'

export default {
    components: { SectionHeading }
};
</script>
